var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 4.5V6H9.75V4.5H2.25Z",
    fill: "#696F88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0632 9.75H2.25V8.25H13.0632L11.25 6.3075L12.2399 5.25L15.75 9L12.2399 12.75L11.25 11.6925L13.0632 9.75Z",
    fill: "#696F88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 13.5H2.25V12H9.75V13.5Z",
    fill: "#696F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarOpen);
export default __webpack_public_path__ + "static/media/sidebar_open.abed85d1de75c3fc0caac22a1838f881.svg";
export { ForwardRef as ReactComponent };